export const QA_NAME_LISTING_PUBLICATION_PRIMARY_ACTION =
  'listingPublicationPrimaryAction'

export const QA_NAME_LISTING_PUBLICATION_ACTIONS_MENU =
  'listingPublicationActionsMenu'
